import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { EmptyState } from '@/routes/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/-features/empty-state';
import { ResultsTable } from '@/routes/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/-features/results-table';
import { LoadingState } from '@/routes/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/-features/loading-state';
import { ErrorState } from '@/routes/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/-features/error-state';
import { WinnerBlock } from '@/routes/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/-features/winner-block';
export const ResultsCard = ({ title, description, comparison, loading, error, itemName, actions, }) => {
    if (loading) {
        return <LoadingState title={title}/>;
    }
    if (error) {
        return <ErrorState title={title}/>;
    }
    if (!comparison || comparison.totalScans === 0 || comparison.results.length === 0) {
        return <EmptyState title={title} description={description}/>;
    }
    const results = comparison.results;
    const winner = comparison.winner;
    return (<Card>
            <CardHeader className="pb-3">
                <div className="flex items-start justify-between gap-4">
                    <div className="space-y-1">
                        <CardTitle className="text-base">{title}</CardTitle>
                        {description && <p className="text-sm text-muted-foreground">{description}</p>}
                    </div>

                    <div className="flex items-center gap-2">
                        <Badge variant="secondary">{comparison.totalScans} scans</Badge>
                        {comparison.totalScans < 20 ? (<Badge variant="outline" className="text-xs">
                                Low data
                            </Badge>) : null}
                        {actions}
                    </div>
                </div>
            </CardHeader>

            <CardContent className="space-y-4">
                {winner && <WinnerBlock winner={winner} itemName={itemName}/>}

                <ResultsTable results={results} itemName={itemName}/>
            </CardContent>
        </Card>);
};
ResultsCard.displayName = 'ResultsCard';
